import { EKycVerificationStatus } from '@exam-center/graphql';
import { Flex, FormTextarea, Label, Text } from '@shared/components';

import { EKYC_APPROVAL_STATUS_TEXT, EKYC_APPROVAL_STATUS_COLOR } from '../../constants';
import { type ProctoringEkycVerificationFormType } from '../../containers';

export interface ProctoringEkycInformationVerificationProps {
  verificationStatus?: ProctoringEkycVerificationFormType['verificationStatus'];
  disabled?: boolean;
}

export default function ProctoringEkycVerificationOutcome(
  props: Readonly<ProctoringEkycInformationVerificationProps>,
) {
  const { verificationStatus, disabled: shouldDisabled } = props;

  const statusKey = verificationStatus as keyof typeof EKYC_APPROVAL_STATUS_COLOR;
  const labelColor = EKYC_APPROVAL_STATUS_COLOR[statusKey];

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), width: '100%' })}>
      <Text
        variant='h4'
        sx={(theme) => ({
          borderLeft: `4px solid ${theme.palette.primary.main}`,
          pl: theme.spacing(4),
        })}
      >
        Verification Outcome
      </Text>
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text
          variant='body1Semibold'
          sx={{
            maxWidth: '240px',
            width: '100%',
          }}
        >
          ผลการตรวจสอบ
        </Text>
        <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4) })}>
          <Label color={labelColor} size='large'>
            {EKYC_APPROVAL_STATUS_TEXT[statusKey]}
          </Label>
          {shouldDisabled ? null : (
            <FormTextarea
              name='comment'
              label={
                <Flex sx={(theme) => ({ gap: theme.spacing(1) })}>
                  <Text variant='body2Semibold'>สาเหตุ</Text>
                  {verificationStatus === EKycVerificationStatus.Rejected ? (
                    <Text variant='body2Semibold' color='error'>
                      *
                    </Text>
                  ) : null}
                </Flex>
              }
              sx={{ width: '400px' }}
            />
          )}
        </Flex>
      </Flex>
    </Flex>
  );
}
